module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/qna-a5b01ba4e96cce2ec2415078e7245d77.svg";